import React from 'react';

const Underline = ({ 
  height = '48px', 
  width = '48px', 
  color = '#335262', 
  secondaryColor = '#72C472'
}) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>underline</title>
    <g>
      <path d="M46,46H2c-0.55225,0-1-0.44775-1-1s0.44775-1,1-1h44c0.55225,0,1,0.44775,1,1S46.55225,46,46,46z" fill={secondaryColor}/>
      <path d="M42,2H29v3l2.48507,0.62127C32.3754,5.84385,33,6.64382,33,7.56155L33,25.182 c0,4.78873-3.60526,8.97701-8.38326,9.29729C19.37654,34.83054,15,30.66649,15,25.5V7.56155 c0-0.91774,0.62459-1.7177,1.51493-1.94029L19,5V2H6v3l2.48507,0.62127C9.37541,5.84385,10,6.64382,10,7.56155L10,25.094 c0,7.52956,5.77449,14.01771,13.29491,14.38859C31.33363,39.87902,38,33.45348,38,25.5V7.56155 c0-0.91774,0.6246-1.7177,1.51493-1.94029L42,5V2z" fill={color} />
    </g>
  </svg>
);

export default Underline;
